// Answer tracking for the sale-list quiz — data to optimize the sale landing later.
// 1) ANONYMOUS, every visitor (incl. SMS): Shopify.analytics.publish + dataLayer custom events (same channel as bs26_tap_to_text),
//    plus data-hc-el on every answer button so HC Pixel element clicks give per-answer counts.
// 2) IDENTIFIED browsers only (email click / past form): Klaviyo profile quiz_* properties + "Quiz Completed" / "Quiz List Saved".
//    Klaviyo skips anonymous browsers. Saving properties is NOT marketing consent.
(function () {
  window.SLQ_EVENTS = window.SLQ_EVENTS || []; // QA log, readable in DevTools

  const qs = new URLSearchParams(location.search);
  const CTX = {
    page_kind: (window.SLQ_PAGE && window.SLQ_PAGE.reg) || qs.get('seg') === 'reg' ? 'reg' : 'signup',
    page_path: location.pathname,
    utm_source: qs.get('utm_source') || '', utm_campaign: qs.get('utm_campaign') || '',
    arrived_via: qs.get('list') ? 'shared-list' : qs.get('for') ? 'shared-quiz' : 'direct',
    shared_for: qs.get('for') || '',
    device: window.matchMedia('(min-width: 900px)').matches ? 'desktop' : 'mobile',
  };
  function publish(name, data) {
    data = Object.assign({}, CTX, data);
    window.SLQ_EVENTS.push(['event', name, data]);
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, data); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (_) {}
  }
  function klaviyo(cmd) {
    window.SLQ_EVENTS.push(cmd);
    try { (window.klaviyo = window.klaviyo || []).push(cmd); } catch (_) { /* never break the quiz for tracking */ }
  }

  function summary(a, slots) {
    const items = slots.map((s) => s.product);
    return {
      quiz_brand: window.SLQ_CONFIG.brand,
      quiz_who: a.who || 'shared-list',
      quiz_recipients: a.recipients || [],
      quiz_moment: a.moment || null,
      quiz_gift_kind: a.giftKind || null,
      quiz_look: a.look || null,
      quiz_count: items.length,
      quiz_picks: items.map((p) => p.handle),
      quiz_page_kind: CTX.page_kind, quiz_utm_campaign: CTX.utm_campaign,
      quiz_list_url: location.origin + location.pathname + '?list=' + items.map((p) => p.handle).join(','),
    };
  }
  const withItems = (a, slots) => Object.assign(summary(a, slots), {
    items: slots.map((s) => ({ for: s.forLabel, design: s.product.design, type: s.product.type, list_price: s.product.list, lowest_price: s.product.p4, image: s.product.imgClean, handle: s.product.handle })),
  });

  window.SLQ_TRACK = {
    // Once per page load: the denominator for every rate (entry = quiz | saved list | shared list).
    view(entry) { publish('bs26_list_quiz_view', { brand: window.SLQ_CONFIG.brand, entry }); },
    // One event per answered question → drop-off per step + answer shares, anonymous.
    step(step, answer) { publish('bs26_list_quiz_step', { brand: window.SLQ_CONFIG.brand, step, answer: String(answer) }); },
    completed(a, slots) {
      const s = summary(a, slots);
      publish('bs26_list_quiz_completed', Object.assign({}, s, { quiz_recipients: s.quiz_recipients.join(','), quiz_picks: s.quiz_picks.join(','), pieces: slots.length }));
      klaviyo(['identify', s]); klaviyo(['track', 'Quiz Completed', withItems(a, slots)]);
    },
    listAction(action, detail) { publish('bs26_list_quiz_action', { brand: window.SLQ_CONFIG.brand, action, detail: detail || '' }); },
    saved(a, slots) { const s = summary(a, slots); klaviyo(['identify', s]); klaviyo(['track', 'Quiz List Saved', withItems(a, slots)]); },
  };
})();
